import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useSimulation= (type) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['simulation', type],
    queryFn: async () => {
      const result = await restClient({ url: `${prefix}/simulation/${type}`});
      return result;
    },
    staleTime: 0,
    cacheTime: 0,
  });
};
